// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xzrvcijjancgrcxlxefp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh6cnZjaWpqYW5jZ3JjeGx4ZWZwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg0MjQwMzIsImV4cCI6MjA1NDAwMDAzMn0.e2AKDZEBBJJ2QAEZSWq0kjt3gJEeAqGknGsPoep1owM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);